module.exports = __webpack_public_path__ + "static/media/aaltouniversity.7ad0838e.png";